import React, { useEffect, useState, useRef } from 'react';
import { Routes, Route, Link, useNavigate, Outlet, useParams } from "react-router-dom";
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';
import toast, { Toaster } from 'react-hot-toast';
import { useSpring, animated, easings } from '@react-spring/web'
import TextareaAutosize from 'react-textarea-autosize';
import { v4 as uuidv4 } from 'uuid';
import ReactGA from "react-ga4";

import { AddBlob, SetBlob, DelBlob, ClearBlob } from './store.js';
import { Static, SaveToast, ShowToast, ShowLoading, ImgResize, ImgUpload, ImgGet, ModalEditPf, ModalEditImg } from './util.js';
import { Adsense } from './ads.js';

import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Accordion from 'react-bootstrap/Accordion';
import { AccordionEventKey } from 'react-bootstrap/AccordionContext';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { Container, Row, Col } from 'react-bootstrap';
import FormRange from 'react-bootstrap/FormRange'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';

import ImgNo from './img/NoImg.png';
import ImgBroken from './img/BrokenImg.png';
import ImgPlayer2 from './img/Player2.png';
import ImgPlayer3 from './img/Player3.png';
import { IoTThingsGraph } from 'aws-sdk';


function Create() {

    const store = useSelector((state) => state);


    const navigate = useNavigate();
    const dispatch = useDispatch();

    const qzListMax = 20;
    const qzQtyMin = 4;
    const qzQtyMax = 12;
    const subLengthMax = 50;
    const ansLengthMax = 50;
    const titleLengthMax = 25;
    const descLengthMax = 50;

    const grpPlayerMin = 3;

    let [loading, loadingSet] = useState(false);

    let create;

    let [title, titleSet] = useState('');
    let [desc, descSet] = useState('');
    let [qzList, qzListSet] = useState([]);

    let [imgqz, imgqzSet] = useState({});


    const taRefSub = useRef([]);
    const taRefAns1 = useRef([]);
    const taRefAns2 = useRef([]);
    const taRefTitle = useRef();
    const taRefDesc = useRef();


    const [isCollapsed, setIsCollapsed] = useState(true);

    const toggleCollapse = () => {
        setIsCollapsed(!isCollapsed);
    };


    const defaultOp = {
        cp: false, // 커플끼리매칭
        rk: true  // 공개랭킹
    }

    let [divQz, divQzSet] = useState('0');
    let [divOp, divOpSet] = useState(false);

    let [op, opSet] = useState(defaultOp);
    let [share, shareSet] = useState(false);
    let [shareMod, shareModSet] = useState(false);
    let [grp, grpSet] = useState('off');
    let [player, playerSet] = useState(5);
    let [expid, expidSet] = useState(0);
    let [exptime, exptimeSet] = useState(48);

    let exptxt = ['30분', '1시간', '6시간', '12시간', '1일'];
    let expdt = [30, 60, 360, 720, 1440];

    let [value1, setValue1] = useState(25);

    let [pfModal, pfModalSet] = useState();
    let pfModalClose = () => pfModalSet(false);

    let tagStr = useRef('');
    let [tagVal, tagValSet] = useState('');
    let [tag, tagSet] = useState([]);


    let [simgShow, simgShowSet] = useState(false);
    let [simg, simgSet] = useState({ img: null, ref: null, ans: null });
    const sImgRef = useRef();



    const [aniStep2, aniStep2Api] = useSpring(() => ({
        from: {
            height: 0,
            opacity: 0,
        },
    }));

    const handleClick = () => {
        aniStep2Api.start({

            to: {
                height: 200,
                opacity: 1,
            },
            config: {
                duration: 1000,
                easing: easings.easeOutQuart
            },
        })
    }



    useEffect(() => {
        const fetchdate = async () => {

            let game = JSON.parse(sessionStorage.getItem('create'));
            let lib = JSON.parse(sessionStorage.getItem('lib'));

            if (game == null) {
                game = UpdateCreate();

                if (lib == null) {
                    navigate('/lib');

                    return;
                }
            }

            console.log(game);
            if (lib != null) {
                sessionStorage.removeItem('lib');
                game.divOp = true;
                game.title = lib.title;
                game.qzList = lib.qzList;
                game.share = false;
                game.tag = [];
                qzListSet([]);
            }


            divOpSet(game.divOp);
            titleSet(game.title);
            descSet(game.sub);
            shareSet(game.share);
            grpSet(game.grp);
            playerSet(game.player);
            expidSet(game.exptime);
            opSet(game.op);
            tagSet(game.tag);


            ChkQzListMax(game.qzList.length);


            const prom = game.qzList.map((d, i) => {

                if (i < qzListMax) {
                    AddQz(d.gid, d.qid, d.qz[0], d.qz[1], d.qz[2], d.qz[3], d.qz[4], d.sid)
                }
            });


            console.log(game);
            await Promise.all(prom);


            divQzSet(game.divOp ? '0' : '1');


            if (game.divOp) {
                ShowDivOp();
            }
        };

        fetchdate();

        ShowToast();

    }, [])

    useEffect(() => {
        UpdateCreate();

    }, [divOp, title, desc, qzList, share, grp, player, exptime, op, tag])

    useEffect(() => {

        tagStr.current = '';
        tag.map((d, i) => {
            tagStr.current += '#' + d;
        })

    }, [tag])


    function UpdateCreate() {
        let game = {
            divOp: divOp,
            title: title,
            sub: desc,
            qzList: qzList,
            share: share,
            grp: grp,
            player: player,
            exptime: exptime,
            op: op,
            tag: tag
        };

        sessionStorage.setItem('create', JSON.stringify(game));

        return game;
    }

    function GetSvrQzImg(type, qid, sid, slot) {
        if (type != 'N') {

            let key = 'lib/' + qid + '-' + slot;

            if (type == '@') {
                key = 'temp/' + sid + slot;
            }
            console.log(key);

            ImgGet(Static.SvrAddr, key).then(res => {
                imgqzSet(old => ({ ...old, [sid + slot]: res }))
            });
        }
    }


    function ChkQzListMax(length) {
        if (length > qzListMax) {
            alert(qzListMax + "문제까지 작성할 수 있어요.");

            return false;
        }

        return true;
    }

    function AddQz(gid, qid, sub, qaA, qaB, qiA, qiB, sid) {


        if (sid == 'new') {
            sid = uuidv4();
        }

        let obj = {
            gid: gid,
            qid: qid,
            qz: [sub, qaA, qaB, qiA, qiB],
            sid: sid,
        }
        qzListSet(old => [...old, obj]);

        GetSvrQzImg(qiA, qid, sid, 'A');
        GetSvrQzImg(qiB, qid, sid, 'B');

    }
    function DelQz(idx, sid) {
        qzListSet(old => {
            const nq = [...old];
            nq.splice(idx, 1);
            return nq;
        })
    }
    function DelQzAll() {
        if (window.confirm('작성한 문제를 모두 삭제 할까요?')) {

            ClearQzList();
        }
    }
    function ClearQzList() {

        qzListSet([]);
    }

    function QzInput(evt, idx, qz) {
        const nl = [...qzList];
        nl[idx].qz[qz] = evt.target.value;
        qzListSet(nl);

    }


    function DoneCreate() {

        let msg = null;
        let ansNull = false;
        qzList.map(function (qz, i) {
            if (!ansNull) {
                if (qz.qz[1].length == 0) {
                    msg = "비어있는 답안이 있어요.";
                    taRefAns1.current[i].focus();
                    ansNull = true;
                }
                else if (qz.qz[1].length > ansLengthMax) {
                    msg = '답안이 너무 길어요.';
                    taRefAns1.current[i].focus();
                    ansNull = true;
                }
                else if (qz.qz[2].length == 0) {
                    msg = "비어있는 답안이 있어요.";
                    taRefAns2.current[i].focus();
                    ansNull = true;
                }
                else if (qz.qz[2].length > ansLengthMax) {
                    msg = '답안이 너무 길어요.';
                    taRefAns2.current[i].focus();
                    ansNull = true;
                }
                else if (qz.qz[0].length > subLengthMax) {
                    msg = '질문이 너무 길어요.';
                    taRefSub.current[i].focus();
                    ansNull = true;
                }
            }
        })

        if (ansNull) {
            alert(msg);
        }
        else if (qzList.length < qzQtyMin) {
            alert(qzQtyMin + "문제 이상 만들어 주세요.");
        }
        else if (qzList.length > qzQtyMax) {
            alert(qzQtyMax + "문제까지 출제할 수 있어요.");
        }
        else {

            if (divOp) {

                if (title == null) {
                    alert("제목을 입력 해 주세요.");
                    taRefTitle.current.focus();
                }
                else if (title.length < 2) {
                    alert("제목을 2 글자 이상 입력 해 주세요.");
                    taRefTitle.current.focus();
                }
                else if (title.length > titleLengthMax) {
                    alert("제목이 너무 길어요.");
                    taRefTitle.current.focus();
                }
                else if (desc.length > descLengthMax) {
                    alert("설명이 너무 길어요.");
                    taRefDesc.current.focus();
                }
                else {
                    if (localStorage.getItem('uuid') == null) {
                        pfModalSet(true);
                    }
                    else {
                        Uploading();
                    }
                }
            }
            else {
                divQzSet('0');
                divOpSet(true);

                ShowDivOp();

                setTimeout(() => {
                    //window.scrollBy({ top: 300, left: 0, behavior: 'smooth' });

                    setTimeout(() => {
                        taRefTitle.current.focus();
                    }, 100);

                }, 100);

            }
        }

    }

    function ShowDivOp() {
        aniStep2Api.start({
            to: {
                height: 200,
                opacity: 1,
            },
            config: {
                //duration: 1000,
                easing: easings.easeOutQuart
            },
        })


    }





    function Uploading() {
        let quiz = [];
        let qzshare = [];
        let lib = [];
        qzList.map((d, i) => {
            quiz = [...quiz, [...d.qz]];

            if (share) {
                let qzs = [d.qz[0], d.qz[1], d.qz[2], d.qz[3] != 'N' ? '@' : 'N', d.qz[4] != 'N' ? '@' : 'N'];
                qzshare = [...qzshare, qzs];
            }
            console.log(qzshare);

            if (d.gid != 0) {
                if (!lib.includes(d.gid)) {
                    lib.push(d.gid);
                }
            }
        })


        if (grp == 'off') {
            op.cp = false;
        }

        const uploadGame = () => {
            return new Promise((resolve) => {
                axios.post(Static.SvrAddr + 'newgame', {
                    title: title,
                    sub: desc,
                    player: grp == 'on' ? player : 2,
                    expdt: exptime * 60,
                    qz: quiz,
                    op: op,
                    maker: localStorage.getItem('nick'),
                    lib: lib.length == [] ? '0' : lib.toString(),
                    user: localStorage.getItem('uuid')
                }).then((res) => {
                    console.log(res);
                    resolve(res.data[0][0].game);
                }).catch(() => {
                    console.log('uploadGame 실패함');
                    resolve(0);
                })
            });
        };

        const uploadLib = () => {
            return new Promise((resolve) => {
                console.log(tagStr.current);
                axios.post(Static.SvrAddr + 'addlib', {
                    title: title,
                    qz: qzshare,
                    tag: tagStr.current,
                    user: localStorage.getItem('uuid')
                }).then((res) => {
                    console.log(res);
                    resolve(res.data[0][0].lib);
                }).catch(() => {
                    console.log('uploadLib 실패함');
                    resolve(0);
                })
            });
        };



        const UploadAll = async () => {
            try {
                loadingSet(true);

                let gameId = 0;
                let libId = 0;

                if (shareMod || share) {
                    const res = await Promise.all([uploadLib()]);
                    libId = res[0];

                    quiz.map((d, i) => {
                        if (d[3] == '@') d[3] = libId + '_' + i;
                        if (d[4] == '@') d[4] = libId + '_' + i;
                    });
                }

                if (!shareMod) {
                    const res = await Promise.all([uploadGame()]);
                    gameId = res[0];
                }


                const uploadImgs = async () => {

                    await Promise.all(

                        qzList.map(async (d, i) => {

                            try {
                                await UploadImg(d.qz[3], d.sid, i, 'A', d.qid, gameId, libId);
                                await UploadImg(d.qz[4], d.sid, i, 'B', d.qid, gameId, libId);

                                return true;
                            }
                            catch (error) {
                                console.error('Error uploading file:', error);
                                return false;
                            }
                        })
                    )
                }


                await uploadImgs();


                ClearQzList();

                localStorage.setItem('noti', 'set');


                setTimeout(() => {

                    sessionStorage.removeItem('create');

                    if (shareMod) {
                        SaveToast('새 게임이 공유 되었어요.');

                        window.location.reload();
                    }
                    else {
                        SaveToast('새 게임이 만들어졌어요.');

                        navigate('/game/' + gameId);
                    }

                    ReactGA.event('create_game', {
                        '문제수': qzList.length,
                        '참가자': grp == 'on' ? player : 2,
                        '매칭랭킹': grp == 'on' ? op.cp : 'false',
                        '커플매칭': grp == 'on' ? op.rk : 'false',
                        '문제공유': share,
                        '태그수': tag.length,
                    });

                }, 500);

            } catch (error) {
                console.error("Error while executing async functions:", error);
                loadingSet(false);
            }
        };



        console.log(lib.toString());

        UploadAll();


    }


    function ClickImg(img, qz, slot) {
        sImgRef.current = img;
        simgSet({ qz: qz, slot: slot });
        simgShowSet(true);
    }

    function UploadImg2(file) {
        console.log(file);

        if (file == null) {
            return;
        }

        let idx = simg.qz;
        let slot = simg.slot;

        const nl = [...qzList];

        if (file == ImgNo) {
            nl[idx].qz[slot + 3] = 'N';
        }
        else {

            let url = URL.createObjectURL(file);

            nl[idx].qz[slot + 3] = '@';

            let key = nl[idx].sid + (slot == 0 ? 'A' : 'B');

            if (!imgqz.hasOwnProperty(key)) {
                imgqzSet(old => ({ ...old, [key]: url }))
            }
            else {
                imgqz[key] = url;
            }

            console.log(key);
            ImgUpload(Static.SvrAddr, file, 'temp/' + key);
        }

        qzListSet(nl);

    }



    function UploadImg(type, sid, idx, slot, qid, key, keylib) {

        if (type == 'N') return;

        let num = '_' + idx + '-' + slot;

        if (type == '@') {

            axios.post(Static.SvrAddr + 'copys3', {
                from: 'temp/' + sid + slot,
                to: share ? 'lib/' + keylib + num : 'qz/' + key + num,
                move: true
            }).then((res) => {
                console.log(res);
            }).catch(() => {
                console.log('실패함');
            })

        }
        else {
            if (share) {
                console.log(qid + '-' + slot);

                axios.post(Static.SvrAddr + 'copys3', {
                    from: 'lib/' + qid + '-' + slot,
                    to: 'lib/' + keylib + num,
                    move: false
                }).then((res) => {
                    console.log(res);
                }).catch(() => {
                    console.log('실패함');
                })
            }
        }
    }





    async function onChangeImg(e, idx, slot, sid) {

        let file = await ImgResize(e.target.files[0], 800);
        console.log(file);

        const nl = [...qzList];

        if (file == null) {
            nl[idx].qz[slot + 3] = 'N';
        }
        else {
            const reader = new FileReader();
            reader.onload = function () {
                const base64String = reader.result.split(',')[1];

                sessionStorage.setItem(sid + (slot == 0 ? 'A' : 'B'), base64String);
            };
            reader.readAsDataURL(file);

            //nl[idx].img[slot] = URL.createObjectURL(file);
            nl[idx].qz[slot + 3] = '@';

        }

        console.log(store.blob);
        qzListSet(nl);
    };



    const aniDiv = useSpring({
        from: {
            height: 0,
            opacity: 0,
        },
        to: {
            height: 200,
            opacity: 1,
        },
        config: {
            duration: 1000,
            easing: easings.easeOutQuart
        },
    });

    function Exp() {
        aniStep2Api.start({
            to: {
                height: 200,
                opacity: 1,
            },
            config: {
                duration: 1000,
                easing: easings.easeOutQuart
            },
        })
    }

    function AddTag() {
        let word = tagVal.replace(/\s+/g, '');
        if (word == '') {
            return;
        }
        if (word.length > 10) {
            alert("태그가 너무 길어요.");
            return;
        }
        if (tag.length > 10) {
            alert("태그가 너무 많아요.");
            return;
        }
        if (!tag.includes(word)) {
            tagSet([word, ...tag]);
        }
        tagValSet('');
    }

    if (!qzList || loading) {
        return ShowLoading()
    }



    return (

        <div className="">



            <div className=''>
                <div className='d-flex justify-content-between fs-3 my-3'>
                    <span>
                        문제 만들기

                        <OverlayTrigger rootClose
                            trigger="click"
                            key='right'
                            placement='right'
                            overlay={
                                <Popover>
                                    <Popover.Body>
                                        최소 {qzQtyMin}문제 이상, 최대 {qzQtyMax}문제까지 출제할 수 있어요. <br></br>
                                        최대 {qzListMax}문제까지 작성할 수 있어요.
                                    </Popover.Body>
                                </Popover>
                            }
                        >
                            <button type="button" className="btn btn-sm text-body-tertiary"><i class="fi-rr-info"></i></button>
                        </OverlayTrigger>
                    </span>

                    <button type="button" className={qzList.length == 0 ? 'btn btn-sm btn-outline-secondary disabled' : 'btn btn-sm btn-outline-secondary'} onClick={() => {
                        DelQzAll()
                    }}><i class="fi fi-rr-trash"></i> 모두 지우기 </button>

                </div>




                <Accordion alwaysOpen activeKey={divQz} onSelect={(e) => {
                    divQzSet(divQz == '1' ? '0' : '1');
                    setTimeout(() => {
                        qzListSet([...qzList])
                    }, 1);
                }}>
                    <Accordion.Item eventKey='1'>
                        <Accordion.Header>
                            <div className='d-flex flex-fill justify-content-between fs-5'>
                                <div className='flex-fill'>
                                    <i class={"fs-4 va-m " + (qzList.length >= qzQtyMin ? 'fi-rr-memo-circle-check text-success' : 'fi-rr-memo text-body-tertiary')}></i> 출제할 문제
                                </div>
                                <div className='mx-3'>
                                    {qzList.length}/{qzQtyMax}
                                </div>
                            </div>

                        </Accordion.Header>
                        <Accordion.Body>
                            {
                                qzList.map(function (d, i) {
                                    return (
                                        <>
                                            <div className=''>
                                                <div className='d-flex flex-row'>
                                                    <div className={i >= 12 ? 'text-danger' : ''}>
                                                        <h1> {i + 1} </h1>
                                                    </div>
                                                    <div className='flex-fill px-3'>
                                                        <TextareaAutosize className='d-inline-flex focus-ring rounded-2 border border-light-subtle p-2'
                                                            id={"sub" + i} placeholder="질문 (선택)" value={d.qz[0]} style={{ width: '100%' }} ref={e => taRefSub.current[i] = e}
                                                            onChange={(e) => {
                                                                QzInput(e, i, 0);
                                                            }} />
                                                    </div>
                                                    <div className='fs-3 text-body-tertiary' onClick={() => {
                                                        DelQz(i, d.sid)
                                                    }}><i class="fi fi-rr-trash"></i>
                                                    </div>

                                                </div>
                                                <div className='row'>
                                                    <div className='d-flex align-items-center align-items-stretch p-2 gap-1'>
                                                        <div className='col d-flex justify-content-center align-items-stretch'>
                                                            {d.qz[3] == 'N' ? (
                                                                <div className='d-flex bg-light flex-fill align-items-center justify-content-center rounded-2'
                                                                    onClick={() => { ClickImg(null, i, 0); }} >
                                                                    <div className='fs-3 rounded-circle text-body-tertiary d-flex justify-content-center pt-1' style={{
                                                                        height: '45px',
                                                                        width: '45px',
                                                                    }}>
                                                                        <i class="fi-rr-file-image"></i>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <img className='rounded-2'
                                                                    src={imgqz[d.sid + 'A']}
                                                                    onClick={() => { ClickImg(imgqz[d.sid + 'A'], i, 0); }}
                                                                    style={{
                                                                        objectFit: 'cover',
                                                                        aspectRatio: 5 / 3,
                                                                        width: '100%',
                                                                    }}
                                                                    onError={(e) => { e.target.src = ImgBroken }}
                                                                />
                                                            )}
                                                        </div>
                                                        <div className='col d-flex justify-content-center align-items-stretch'>
                                                            {d.qz[4] == 'N' ? (
                                                                <div className='d-flex bg-light flex-fill align-items-center justify-content-center rounded-2'
                                                                    onClick={() => { ClickImg(null, i, 1); }}>
                                                                    <div className='fs-3 text-body-tertiary d-flex justify-content-center pt-1' style={{
                                                                        height: '45px',
                                                                        width: '45px',
                                                                    }}>
                                                                        <i class="fi-rr-file-image"></i>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <img className='rounded-2'
                                                                    src={imgqz[d.sid + 'B']}
                                                                    onClick={() => { ClickImg(imgqz[d.sid + 'B'], i, 1); }}
                                                                    style={{
                                                                        objectFit: 'cover',
                                                                        aspectRatio: 5 / 3,
                                                                        width: '100%'
                                                                    }}
                                                                    onError={(e) => { e.target.src = ImgBroken }}
                                                                />
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className='d-flex gap-1'>

                                                        <div className='col'>
                                                            <TextareaAutosize className='d-inline-flex focus-ring rounded-2 border border-light-subtle p-2'
                                                                id={"ql" + i} placeholder="답안 A" value={d.qz[1]} style={{ width: '100%' }} ref={e => taRefAns1.current[i] = e}
                                                                onChange={(e) => {
                                                                    QzInput(e, i, 1);
                                                                }} />
                                                        </div>
                                                        <div className='col'>
                                                            <TextareaAutosize className='d-inline-flex focus-ring rounded-2 border border-light-subtle p-2'
                                                                id={"qr" + i} placeholder="답안 B" value={d.qz[2]} style={{ width: '100%' }} ref={e => taRefAns2.current[i] = e}
                                                                onChange={(e) => {
                                                                    QzInput(e, i, 2);
                                                                }} />
                                                        </div>


                                                    </div>
                                                </div>
                                            </div>
                                            <hr></hr>
                                        </>
                                    )
                                })
                            }


                            <div className='d-flex gap-2'>
                                <button type="button" className='btn btn-primary flex-fill' onClick={() => {
                                    navigate('/lib')
                                }}><i class="fi-rr-square-plus va-m"></i> 가져오기 </button>
                                <button type="button" className='btn btn-outline-primary' onClick={() => {
                                    { ChkQzListMax(qzList.length + 1) && AddQz(0, 0, '', '', '', 'N', 'N', 'new') }
                                }}><i class="fi-rr-square-plus va-m"></i> 직접입력 </button>

                            </div>


                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>


                <div className='my-3'>
                    <Adsense type={'dp'} />
                </div>

                <hr></hr>


                {!divOp ? (
                    <>
                        <div className='d-flex align-items-end flex-column p-3'>
                            <Button className='btn-lg rounded-5' onClick={() => { DoneCreate() }}> 다음 <i class="fi-rr-angle-small-right va-m"></i> </Button>
                        </div>
                    </>
                ) : (
                    <>



                        <div className='d-flex justify-content-between fs-3 py-1'>
                            게임 설정
                        </div>


                        <div className='px-4 my-3'>
                            <div className='text-start fs-6'>
                                제목
                            </div>
                            <TextareaAutosize id='#title' className='d-inline-flex focus-ring rounded-2 border border-light-subtle p-2 '
                                placeholder="제목 입력" value={title} style={{ width: '100%' }} ref={taRefTitle}
                                onChange={(e) => {
                                    titleSet(e.target.value)
                                }} />

                        </div>

                        {!shareMod && (
                            <>
                                <div className='px-4 my-3'>
                                    <div className='text-start fs-6'>
                                        설명 (선택)
                                    </div>
                                    <TextareaAutosize className='d-inline-flex focus-ring rounded-2 border border-light-subtle p-2 '
                                        placeholder="설명 입력" value={desc} style={{ width: '100%' }} ref={taRefDesc}
                                        onChange={(e) => {
                                            descSet(e.target.value)
                                        }} />

                                </div>
                            </>
                        )}




                        {!shareMod && (
                            <>
                                <div className='d-flex btn-group px-4 py-2 width-es'>
                                    <input type="radio" className="btn-check" name="player" id="player1" autocomplete="off" value="off" onChange={(e) => { grpSet(e.target.value) }} checked={grp === 'off'} />
                                    <label className="btn btn-outline-primary" for="player1">
                                        <img src={ImgPlayer2} style={{ height: '70px' }} />
                                        둘이하기</label>
                                    <input type="radio" className="btn-check" name="player" id="player2" autocomplete="off" value="on" onChange={(e) => { grpSet(e.target.value) }} checked={grp === 'on'} />
                                    <label className="btn btn-outline-primary" for="player2">
                                        <img src={ImgPlayer3} style={{ height: '70px' }} />
                                        셋 이상</label>
                                </div>




                                {grp == 'on' ? (<>
                                    <div className='text-start fs-6 fw-light px-4'>
                                        최대 20명과 궁합을 볼 수 있어요. 모든 친구가 참여하거나 게임이 마감되면 결과를 볼 수 있어요.
                                    </div>
                                    <div className='p-4'>
                                        <div className='fs-1'>{player}</div>
                                        최대 참가자
                                        <input type="range" className="form-range px-4" min={op.cp ? "4" : "3"} max="20" value={player} onChange={(e) => { playerSet(e.target.value) }} />
                                    </div>

                                </>) : (<>
                                    <div className='text-start fs-6 fw-light px-4'>
                                        친구와 내가 게임을 마치면 결과를 볼 수 있어요.
                                    </div>
                                </>)}

                                {/* <br></br>
                                    <div className='fs-1'>{exptime}</div>
                                    참여 제한 시간
                                    <input type="range" className="form-range" min="1" max="24" value={exptime} onChange={(e) => { exptimeSet(e.target.value) }} />
                                    <br></br> */}


                                {grp == 'on' ? (<>
                                    <div className='px-4 py-1'>
                                        <div className="form-check form-switch form-check-reverse">
                                            <label className='d-flex align-items-center'>
                                                <div className='flex-fill text-start'>
                                                    매칭 랭킹 보기
                                                </div>
                                                <div className='pb-2 pe-4'>
                                                    <input className="form-check-input fs-1" type='checkbox' checked={op.rk} onChange={(e) => { op.rk = e.target.checked; opSet({ ...op }) }}></input>
                                                </div>
                                            </label>
                                        </div>
                                        <div className='text-start fs-6 fw-light'>
                                            최고 궁합의 커플 순위가 모두에게 공개돼요.
                                        </div>
                                    </div>
                                    <div className='px-4 py-1'>
                                        <div className="form-check form-switch form-check-reverse">
                                            <label className='d-flex align-items-center'>
                                                <div className='flex-fill text-start'>
                                                    이성끼리 궁합 보기
                                                </div>
                                                <div className='pb-2 pe-4'>
                                                    <input className="form-check-input fs-1" type='checkbox' checked={op.cp} onChange={(e) => {
                                                        op.cp = e.target.checked;
                                                        opSet({ ...op });
                                                        e.target.checked ? (player == "3" && playerSet("4")) : (player == "4" && playerSet("3"));
                                                    }}></input>
                                                </div>
                                            </label>
                                        </div>
                                        <div className='text-start fs-6 fw-light'>
                                            남, 여끼리 매칭돼요. 남, 여 각각 최소 2인 이상이 참여해야 해요.
                                        </div>
                                    </div>
                                </>) : (<>
                                </>)}



                                {/* <Accordion>
                                        <Accordion.Item eventKey="0">
                                            <Accordion.Header>세부 옵션</Accordion.Header>
                                            <Accordion.Body>
                                                <div className='vstack gap-2 ps-3 pe-5'>

                                                    <div className="form-check form-switch form-check-reverse ">
                                                        <label className='d-flex align-items-center'>
                                                            <div className='flex-fill text-start'>
                                                                댓글 달기 가능
                                                            </div>
                                                            <div className='pb-2'>
                                                                <input className="form-check-input fs-1" type='checkbox'></input>
                                                            </div>
                                                        </label>
                                                    </div>
                                                    <div className="form-check form-switch form-check-reverse ">
                                                        <label className='d-flex align-items-center'>
                                                            <div className='flex-fill text-start'>
                                                                친구 이름 보이게
                                                            </div>
                                                            <div className='pb-2'>
                                                                <input className="form-check-input fs-1" type='checkbox'></input>
                                                            </div>
                                                        </label>
                                                    </div>
                                                </div>

                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion> */}

                            </>
                        )}



                        <hr></hr>

                        <div className='d-flex justify-content-between fs-3 '>
                            공유 설정
                        </div>

                        <div className='p-4'>
                            <div className="form-check form-switch form-check-reverse">
                                <label className='d-flex align-items-center'>
                                    <div className='flex-fill text-start'>
                                        문제 공유
                                    </div>
                                    <div className='pb-2 pe-4'>
                                        <input className="form-check-input fs-1" type='checkbox' checked={share} onChange={(e) => {
                                            Exp(); shareSet(e.target.checked);
                                            if (!e.target.checked) {
                                                shareModSet(false);
                                            }
                                        }}></input>
                                    </div>
                                </label>
                            </div>
                            <div className='text-start fs-6 fw-light'>
                                만든 문제들이 서버에 저장되고 다른 유저들이 사용 할 수 있어요. 부적절한 내용이 포함된 경우 통보없이 삭제 될 수 있어요.
                            </div>
                        </div>

                        {share && (
                            <>
                                <div className='px-4'>
                                    <div className='d-flex gap-2'>
                                        <div class="input-group mb-2">
                                            <span class="input-group-text">#</span>
                                            <input type="text" class="form-control" placeholder="태그 입력 (선택)" enterkeyhint="enter" maxLength={30} value={tagVal} onChange={(e) => {
                                                tagValSet(e.target.value);
                                            }}
                                                onKeyDown={(e) => {
                                                    if (e.nativeEvent.isComposing || e.target.value == '') {
                                                        return;
                                                    }

                                                    if (e.code === 'Enter' || e.code === 'NumpadEnter' || e.key === 'Enter') {
                                                        AddTag();
                                                    }
                                                }}
                                            />
                                        </div>
                                        <div className='' style={{ width: '100px' }}>
                                            <button type="button" class="btn btn-outline-secondary" onClick={() => { AddTag() }}> + 추가</button>
                                        </div>
                                    </div>
                                    <div className='d-flex flex-wrap'>
                                        {tag.map((d, i) => {
                                            return (
                                                <label><div className='d-flex bg-secondary-subtle border rounded-3 ps-2 py-1 m-1'
                                                    onClick={(e) => {
                                                        tagSet(tag.filter((tag, index) => index !== i));

                                                    }}>
                                                    {d}<i class="fi-rr-cross-small va-m text-black-50"></i>
                                                </div></label>
                                            )
                                        })}
                                    </div>
                                </div>


                                <div className='px-4 py-4' style={aniStep2}>
                                    <div className="form-check form-switch form-check-reverse">
                                        <label className='d-flex align-items-center'>
                                            <div className='flex-fill text-start'>
                                                문제만 공유하기
                                            </div>
                                            <div className='pb-2 pe-4'>
                                                <input className="form-check-input fs-1" type='checkbox' checked={shareMod} onChange={(e) => { shareModSet(e.target.checked) }}></input>
                                            </div>
                                        </label>
                                    </div>
                                    <div className='text-start fs-6 fw-light'>
                                        문제만 서버에 저장되고 게임을 플레이 할 수 없어요.
                                    </div>
                                </div>
                            </>

                        )}

                        <hr></hr>

                        <div className='d-flex align-items-end flex-column'>
                            <Button className='btn-lg rounded-5' onClick={() => { DoneCreate() }}> 게임 만들기 <i class="fi-rr-check-circle va-m"></i></Button>
                        </div>

                    </>
                )}


                <div className='my-3'>
                    <Adsense type={'ia'} />
                </div>


                <ModalEditPf show={pfModal} handleClose={pfModalClose} playmod={false} sexmod={false} cpmod={false} cb={() => { Uploading() }} />

                <ModalEditImg show={simgShow} handleClose={() => { simgShowSet(false) }} imgSrc={sImgRef.current} imgNull={ImgNo} cbUpload={(d) => { UploadImg2(d) }} />

            </div>

            <Toaster />

        </div >


    )
}

export default Create;
